import { render, staticRenderFns } from "./WidgetActivitySiteDestiN1.vue?vue&type=template&id=2d777918&scoped=true"
import script from "./WidgetActivitySiteDestiN1.vue?vue&type=script&lang=js"
export * from "./WidgetActivitySiteDestiN1.vue?vue&type=script&lang=js"
import style0 from "./WidgetActivitySiteDestiN1.vue?vue&type=style&index=0&id=2d777918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d777918",
  null
  
)

export default component.exports